export default {
    getFilteredSubKategori : (state) => (id) => state.subKategoriList.filter(v => v.kategori.id === id),
    findQurban : (state) => name => state.qurbanList.find(v => v.name === name)
}
